<template>
    <div id="applicant-project-feedback">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item" @click="$router.push('/projects')" style="cursor: pointer">Proyectos</li>
                <li class="breadcrumb-item active">Encuesta de Satisfacción </li>
            </ol>
        </nav>

        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <!-- TABS -->
                    <vs-tabs>
                        <!-- RESUMEN DE ENCUESTA -->
                        <vs-tab label="Resumen" icon="dashboard">
                            <div class="row">
                                <!-- RESUMEN RED GIRASOL -->
                                <div class="col-md-6 col-sm-12">
                                    <md-card>
                                        <md-card-content>
                                            <h2 class="custom-font mb-4 bold">Resumen <span class="custom-orange">RedGirasol</span>.</h2>
                                            <vs-divider></vs-divider>
                                            <!-- FILTROS -->
                                            <div>
                                                <p class="bold black">Fechas a consultar</p>
                                                <div class="row">
                                                    <div class="col-md-5 col-sm-12">
                                                        <label for="start">Inicio</label>
                                                        <datepicker 
                                                        class="w-full"
                                                        name="start"
                                                        v-model.lazy="rg_start"
                                                        description="Fecha Inicio"
                                                        :language="es"
                                                        :use-utc="true"
                                                        format="yyyy-MM-dd"/>
                                                    </div>
                                                    <div class="col-md-5 col-sm-12">
                                                        <label for="end">Fin</label>
                                                        <datepicker 
                                                        class="w-full"
                                                        description="Fecha Fin"
                                                        name="end"
                                                        v-model.lazy="rg_end"
                                                        :language="es"
                                                        :use-utc="true"
                                                        format="yyyy-MM-dd"/>
                                                    </div>
                                                    <div class="col-md-2 col-sm-12" style="padding-top: 1.8rem;">
                                                        <vs-button @click="getRGValues()" color="warning" type="filled" icon-pack="feather" icon="icon-search"></vs-button>
                                                    </div>
                                                </div>

                                            </div> 
                                            <!--  -->
                                            <vs-divider></vs-divider>
                                            <!-- ESTADISTICA -->
                                            <div>   
                                                <p class="bold black">¿Cómo te califican tus clientes?</p>
                                                <div id="service">
                                                    <statistics-feedback
                                                        title="Servicio / Atención a Cliente."
                                                        :score="values.values[0].average != null ? values.values[0].average: 0"
                                                        :value="5"
                                                        :percent="getPercentage(values.values[0].average != null ? values.values[0].average: 0)"
                                                        color="#f39200" />
                                                </div>
                                                <div id="credit">
                                                    <statistics-feedback
                                                        title="Trámite / Obtención de Crédito."
                                                        :score="values.values[1].average != null ? values.values[1].average: 0"
                                                        :value="5"
                                                        :percent="getPercentage(values.values[1].average != null ? values.values[1].average: 0)"
                                                        color="#f39200" />
                                                </div>
                                                <div id="rg">
                                                    <statistics-feedback
                                                        title="¿Recomendarías RedGirasol?"
                                                        :score="values.values[2].average != null ? values.values[2].average: 0"
                                                        :value="5"
                                                        :percent="getPercentage(values.values[2].average != null ? values.values[2].average: 0)"
                                                        color="#f39200" />
                                                </div>
                                                <div id="average">
                                                    <statistics-feedback
                                                        title="Promedio."
                                                        :score="values.average != null ? values.average : 0"
                                                        :value="5"
                                                        :percent="getPercentage(values.average != null ? values.average : 0)"
                                                        color="#2d2d2d" />
                                                </div>
                                                <p class="bold black mt-4" style="float: right;">Total Encuestas: <span class="custom-orange">{{total}}</span></p>
                                            </div>
                                            <!--  -->
                                            <vs-divider></vs-divider>
                                            <!-- COMENTARIOS -->
                                            <div class="mt-6">
                                                <vs-button :disabled="commentsRG == 0" @click="popupActivo = true, isRG = true" color="warning" type="border" icon-pack="feather" icon="icon-eye">Ver comentarios</vs-button>
                                            </div>
                                        </md-card-content>
                                    </md-card>
                                </div>
                                <!--  -->

                                <!-- RESUMEN POR PROVEDOR / PROYECTO -->
                                <div class="col-md-6 col-sm-12">
                                    <md-card>
                                        <md-card-content>
                                            <h2 class="custom-font mb-4 bold">Resumen <span class="custom-orange">Proveedor / Proyecto</span>.</h2>
                                            <vs-divider></vs-divider>
                                            <!-- FILTROS -->
                                            <div>
                                                <p class="bold black">Fechas a consultar</p>
                                                <div class="row">
                                                    <div class="col-md-6 col-sm-12">
                                                        <label for="start">Inicio</label>
                                                        <datepicker 
                                                        class="w-full"
                                                        name="start"
                                                        v-model.lazy="sp_start"
                                                        description="Fecha Inicio"
                                                        :language="es"
                                                        :use-utc="true"
                                                        format="yyyy-MM-dd"/>
                                                    </div>
                                                    <div class="col-md-6 col-sm-12">
                                                        <label for="end">Fin</label>
                                                        <datepicker 
                                                        class="w-full"
                                                        description="Fecha Fin"
                                                        name="end"
                                                        v-model.lazy="sp_end"
                                                        :language="es"
                                                        :use-utc="true"
                                                        format="yyyy-MM-dd"/>
                                                    </div>
                                                </div>

                                            </div> 
                                            <div class="mt-6">
                                                <p class="bold black">Filtrar por</p>
                                                <div class="row">
                                                    <div class="col-md-4 col-sm-12">
                                                        <vs-radio @change="handleChange()" color="warning" v-model="type" :vs-value="0">Proyecto</vs-radio>
                                                        <vs-radio @change="handleChange()" color="warning" v-model="type" :vs-value="1">Proveedor</vs-radio>
                                                    </div>
                                                    <div class="col-md-6 col-sm-12">
                                                        <!-- <label for="id">{{type ? 'Id de proveedor (SID)' : 'Id de proyecto (PID)'}}</label> -->
                                                        <vs-input name="id" class="inputx" :placeholder="type == 1 ? 'SID':'PID'" v-model.number="id"/>
                                                    </div>
                                                    <div class="col-md-2 col-sm-12">
                                                        <vs-button @click="validateId()" color="warning" type="filled" icon-pack="feather" icon="icon-search"></vs-button>
                                                    </div>
                                                    <div v-if="!isGlobal && hasToShow" class="col-md-12 mt-4 mb-0">
                                                        <p class="bold mb-0 black">{{type == 1 ? "SID" : "PID"}}: <span class="custom-orange">{{extraData.id}}</span></p>
                                                        <p class="bold mb-0 black">{{type == 1 ? "Nombre comercial" : "Alias"}}: <span class="custom-orange">{{extraData.name}}</span></p>
                                                        <p v-if="type == 0" class="bold mb-0 black">SID: <span class="custom-orange">{{extraData.supplier_id}}</span></p>
                                                    </div>
                                                </div>
                                            </div>
                                            <!--  -->
                                            <vs-divider></vs-divider>
                                            <!-- ESTADISTICA -->
                                            <div v-if="hasToShow">
                                                <div>   
                                                    <p v-if="isGlobal" class="bold orange">Promedio General Proveedores</p>
                                                    <p v-else class="bold orange">¿Cómo te califican tus clientes?</p>
                                                    <div id="service_sp">
                                                        <statistics-feedback
                                                            title="Servicio / Atención a Cliente."
                                                            :score="valuesSP.serviceAvg != null ? valuesSP.serviceAvg: 0"
                                                            :value="5"
                                                            :percent="getPercentage(valuesSP.serviceAvg != null ? valuesSP.serviceAvg: 0)"
                                                            color="#f39200" />
                                                    </div>
                                                    <div id="credit_sp">
                                                        <statistics-feedback
                                                            title="Instalación/Entrega del Proyecto."
                                                            :score="valuesSP.projectAvg != null ? valuesSP.projectAvg: 0"
                                                            :value="5"
                                                            :percent="getPercentage(valuesSP.projectAvg != null ? valuesSP.projectAvg: 0)"
                                                            color="#f39200" />
                                                    </div>
                                                    <div id="sp">
                                                        <statistics-feedback
                                                            title="¿Recomendarías al Proveedor?"
                                                            :score="valuesSP.single != null ? valuesSP.single: 0"
                                                            :value="5"
                                                            :percent="getPercentage(valuesSP.single != null ? valuesSP.single: 0)"
                                                            color="#f39200" />
                                                    </div>
                                                    <div id="average_sp">
                                                        <statistics-feedback
                                                            title="Promedio."
                                                            :score="valuesSP.average != null ? valuesSP.average : 0"
                                                            :value="5"
                                                            :percent="getPercentage(valuesSP.average != null ? valuesSP.average : 0)"
                                                            color="#2d2d2d" />
                                                    </div>
                                                    <p class="bold black mt-4" style="float: right;">Total Encuestas: <span class="custom-orange">{{totalSP}}</span></p>
                                                </div>
                                                <!--  -->
                                                <vs-divider></vs-divider>
                                                <!-- COMENTARIOS -->
                                                <div class="mt-6">
                                                    <vs-button :disabled="commentsSP == 0" @click="popupActivo = true, isRG = false" color="warning" type="border" icon-pack="feather" icon="icon-eye">Ver comentarios</vs-button>
                                                </div>
                                            </div>
                                            <div v-else style="text-align: center;" class="mt-2">
                                                <h6 class="custom-font">No se ha realizado ninguna búsqueda 
                                                    <br> puedes regresar al Promedio General
                                                    <br>de Proveedores dando clic <a @click="getRGValues(false, 3);" style="cursor:pointer;">aquí</a>
                                                </h6>
                                            </div>
                                        </md-card-content>
                                    </md-card>
                                </div>
                                <!--  -->
                            </div>
                        </vs-tab>
                        <!-- RESUMEN DE ENCUESTA -->

                        <!-- ENCUESTAS PENDIENTES -->
                        <vs-tab label="Encuestas pendientes" icon="question_answer">
                            <vx-card title="Proyectos con encuesta de servicio pendiente por contestar.">
                                <span>Parametros de consulta: project.status = 7 u 8, project.installation_date menos a 6 meses.</span>
                                <br><vs-table ref="table" stripe search pagination max-items="15" :data="pendingProjects" noDataText="No hay datos disponibles">
                                    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between mt-4"></div>
                                    <template slot="thead">
                                        <vs-th v-for="(col, idx) in columns" v-bind:key="idx" :sort-key="col.sortable ? col.key : null" >{{col.title}}</vs-th>
                                    </template>

                                    <template slot-scope="{data}">
                                        <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                                        <vs-td>
                                            <router-link :to="`/project/${tr.PID}`">
                                                <strong>PID:</strong> {{ tr.PID }} 
                                                <br><strong>{{ tr.ALIAS}}</strong>
                                            </router-link>
                                        </vs-td>
                                        <vs-td>
                                            <strong>SID:</strong> {{ tr.SID }} 
                                            <br><strong>{{ tr.TRADENAME}}</strong>
                                        </vs-td>
                                        <vs-td>
                                            <strong>{{tr.CLIENT_NAME}}</strong>
                                            <br> Email: {{tr.EMAIL}}
                                            <br> Tel: {{phoneFormat(tr.TELEPHONE)}}
                                        </vs-td>
                                        <vs-td>
                                            {{ dateTimeFormat(tr.DATE) != null ? dateTimeFormat(tr.DATE) : "No se ha enviado la encuesta" }}
                                        </vs-td>
                                        <vs-td>
                                            <a :href="getURL(tr)" target="_blank" rel="noopener">{{getURL(tr)}}</a>
                                        </vs-td>
                                        <vs-td>
                                            <vs-button @click="sendSurveyEmails(tr.PID)" size="small" color="primary" type="line">Enviar Encuesta</vs-button>
                                        </vs-td>
                                        </vs-tr>
                                    </template>
                                </vs-table>
                            </vx-card>
                        </vs-tab>
                        <!-- ENCUESTAS PENDIENTES -->

                        <!-- ENCUESTAS CONTESTADAS -->
                        <vs-tab label="Encuestas atendidas" icon="reply_all">
                            <vx-card title="Proyectos con encuesta de servicio atendidas por solicitante.">
                                <span>Parametros de consulta: project.status = 7 u 8, project.installation_date menos a 6 meses.</span>
                                <vs-table ref="table" stripe search pagination max-items="15" :data="answeredProjects" noDataText="No hay datos disponibles">
                                    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between mt-4"></div>
                                    <template slot="thead">
                                        <vs-th v-for="(col, idx) in columns_answered" v-bind:key="idx" :sort-key="col.sortable ? col.key : null" >{{col.title}}</vs-th>
                                    </template>

                                    <template slot-scope="{data}">
                                        <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                                        <vs-td>
                                            <router-link :to="`/project/${tr.PID}`">
                                                <strong>PID:</strong> {{ tr.PID }} 
                                                <br><strong>{{ tr.ALIAS}}</strong>
                                            </router-link>
                                        </vs-td>
                                        <vs-td>
                                            <strong>SID:</strong> {{ tr.SID }} 
                                            <br><strong>{{ tr.TRADENAME}}</strong>
                                        </vs-td>
                                        <vs-td>
                                            <strong>{{tr.CLIENT_NAME}}</strong>
                                            <br> Email: {{tr.EMAIL}}
                                            <br> Tel: {{phoneFormat(tr.TELEPHONE)}}
                                        </vs-td>
                                        <vs-td>
                                            {{ dateTimeFormat(tr.DATE) != null ? dateTimeFormat(tr.DATE) : "No se ha enviado la encuesta" }}
                                        </vs-td>
                                        <vs-td>
                                            {{ dateTimeFormat(tr.RESPONSE_DATE) != null ? dateTimeFormat(tr.RESPONSE_DATE) : "No se ha enviado la encuesta" }}
                                        </vs-td>
                                        <vs-td>
                                            <vs-button @click="getSurvey(tr)" size="small" color="primary" type="line">Ver Encuesta</vs-button>
                                        </vs-td>
                                        </vs-tr>
                                    </template>
                                </vs-table>
                            </vx-card>
                        </vs-tab>
                        <!-- ENCUESTAS CONTESTADAS -->
                    </vs-tabs>
                    <!-- TABS -->
                </div>
            </div>
        </div>
        <!-- MODAL COMENTARIOS -->
        <vs-popup title="Comentarios" :active.sync="popupActivo">
            <vs-list :key="index" v-for="(comment, index) in isRG ? commentsRG : commentsSP">
                <vs-list-header :title="`PID ${comment.pid} - ${comment.alias}`" color="warning"></vs-list-header>
                <vs-list-item :title="`CID ${comment.cid} - ${comment.name}`" :subtitle="comment.answer">
                    <vs-chip color="dark">{{dateTimeFormat(comment.date)}}</vs-chip>
                    <template slot="avatar">
                    <vs-avatar style="margin-right: 1rem;" vs-text="Vue"/>
                    </template>
                </vs-list-item>
            </vs-list>
        </vs-popup>
        <!--  -->
        <!-- MODAL ENCUESTA -->
        <vs-popup :title="`Encuesta para PID: ${projectSelected.PID} - ${projectSelected.ALIAS}`" :active.sync="popupActivoSurvey" fullscreen>
            <vs-table ref="table" stripe :data="survey" noDataText="No hay datos disponibles" >
                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between mt-4"></div>
                <template slot="thead">
                    <vs-th v-for="(col, idx) in columns_survey" v-bind:key="idx" :sort-key="col.sortable ? col.key : null" >{{col.title}}</vs-th>
                </template>

                <template slot-scope="{data}">
                    <template v-for="(tr, indextr) in data">
                        <vs-tr v-if="tr.type == 'SP_QUESTION'" :key="indextr"  :data="tr">
                            <vs-td>
                                {{tr.question}} <br>
                                <small>{{tr.indications}}</small>
                            </vs-td>
                            <vs-td>
                                {{getQuestionType(tr)}}
                            </vs-td>
                            <vs-td>
                                {{getYesOrNOAnswers(tr)}}
                            </vs-td>
                        </vs-tr>
                    </template>
                    <template v-for="(tr, indextr) in data">
                        <vs-tr v-if="tr.type == 'RG_QUESTION'" :key="indextr"  :data="tr">
                            <vs-td>
                                {{tr.question}} <br>
                                <small>{{tr.indications}}</small>
                            </vs-td>
                            <vs-td>
                                {{getQuestionType(tr)}}
                            </vs-td>
                            <vs-td>
                                {{getYesOrNOAnswers(tr)}}
                            </vs-td>
                        </vs-tr>
                    </template>
                </template>
            </vs-table>
        </vs-popup>
        <!--  -->
    </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import dateHelper from "@mixins/dateHelper";
import formatHelper from "@mixins/formatHelper";
import moment from 'moment'
import { es } from "vuejs-datepicker/dist/locale";
import StatisticsFeedback from '../../../components/projectsv2/StatisticsFeedback.vue';

const rgQuestionIds = [];
const spQuestionIds = [64,65,66];

const columns = [
    { title: "PROYECTO", key: "project", sortable: false}
    , { title: "PROVEEDOR", key: "supplier", sortable: false}
    , { title: "SOLICITANTE", key: "applicant", sortable: false}
    , { title: "FECHA DE SOLICITUD", key: "date_request", sortable: false}
    , { title: "URL", key: "url", sortable: false}
    , { title: "ACCIONES", key: "delete", sortable: false}
];

const columns_answered = [
    { title: "PROYECTO", key: "project", sortable: false}
    , { title: "PROVEEDOR", key: "supplier", sortable: false}
    , { title: "SOLICITANTE", key: "applicant", sortable: false}
    , { title: "FECHA DE SOLICITUD", key: "date_request", sortable: false}
    , { title: "FECHA DE RESPUESTA", key: "date_answered", sortable: false}
    , { title: "ACCIONES", key: "delete", sortable: false}
];
const columns_survey = [
    { title: "PREGUNTA", key: "project", sortable: false}
    , { title: "TIPO", key: "applicant", sortable: false}
    , { title: "RESPUESTA", key: "supplier", sortable: false}
];

const URL_PATH = "https://app.redgirasol.com/encuesta/?";

export default {
    mixins: [dateHelper, formatHelper],
    components: {
        Datepicker,
        StatisticsFeedback
    },
    data(){
        return {
            es: es
            , rg_start: "2020-11-01"
            , rg_end: "2020-11-30"
            , sp_start: "2020-11-01"
            , sp_end: "2020-11-30"
            , type: false
            , id: ""
            , popupActivo: false
            , rgQuestionIds: rgQuestionIds
            , spQuestionIds: spQuestionIds
            , values: {
                average: 0,
                values: [
                    {
                        question_id: 0,
                        average: 0,
                    },
                    {
                        question_id: 0,
                        average: 0,
                    },
                    {
                        question_id: 0,
                        average: 0,
                    }
                ]
            }
            , valuesSP: {
                serviceAvg: 0
                , projectAvg: 0
                , single: 0
                , average: 0
            }
            , commentsRG: [
                {
                    question_id: "",
                    answer: "",
                    date: "",
                    name: "",
                    pid: "",
                    alias: "",
                    cid: "",
                },
            ]
            , commentsSP: [
                {
                    question_id: "",
                    answer: "",
                    date: "",
                    name: "",
                    pid: "",
                    alias: "",
                    cid: "",
                },
            ]
            , isRG: true
            , isGlobal: true
            , hasToShow: false
            , extraData: {}
            , total: 0
            , totalSP: 0
            , pendingProjects: []
            , columns: columns
            , columns_answered: columns_answered
            , answeredProjects: []
            , survey: []
            , popupActivoSurvey: false
            , columns_survey: columns_survey
            , projectSelected: {}
        }
    },
    async created() {
        this.showLoading(true);
        let end = moment().locale("es").format('YYYY-MM-DD');
        let start = moment().subtract(1, "years").format('YYYY-MM-DD');
        this.rg_start = start;
        this.rg_end = end;
        this.sp_start = start;
        this.sp_end = end;
        await this.getRGValues();
        await this.getRGValues(false, 3);
        await this.getPendingProjects();
        await this.getPendingProjects(2);
        this.showLoading(false);
    },
    methods: {
        async getRGValues(isRg = true, type = 2){
            this.showLoading(true);
            try{
                let payload;
                if(isRg){
                    payload = {
                        isRg: isRg
                        , type: type
                        , id: null
                        , start: this.rg_start
                        , end: this.rg_end
                    };
                } else {
                    payload = {
                        isRg: isRg
                        , type: type == 3 ? type : this.type
                        , id: this.id
                        , start: this.sp_start
                        , end: this.sp_end
                    };
                }
                let response = await axios.post('/api/applicant_satisfaction_survey/getApplicantSurveyResponses', payload);
                if(isRg){
                    this.values = response.data.values;
                    this.commentsRG = response.data.comments;
                    this.total = response.data.total;
                } else {
                    this.valuesSP = this.calculateValuesSP(response.data.values);
                    this.commentsSP = response.data.comments;
                    this.extraData = response.data.extraData;
                    this.totalSP = response.data.total;
                    this.hasToShow = true;
                }
            } catch(err){
                this.failedOperationNotif("Error al cargar");
            }
            this.showLoading(false);
        },
        getPercentage(value) {
            return (value * 100) / 5;
        },
        validateId(){
            if(this.id != "" && this.id != 0){
                this.getRGValues(false);
                this.isGlobal = false;
            } else {
                this.getRGValues(false, 3);
                this.isGlobal = true;
            }
        },
        handleChange() {
            console.log("cambió");
            this.extraData = {};
            this.hasToShow = false;
            this.id = "";
        },
        async getPendingProjects(type = 1){
            try {
                let response = await axios.get(`/api/applicant_satisfaction_survey/getPendingProjects/${type}`);
                if(type == 1){
                    this.pendingProjects = response.data;
                } else {
                    this.answeredProjects = response.data;
                }
            } catch (error) {
                console.warn(error);
            }
        },
        async sendSurveyEmails(project_id){
            this.showLoading(true);
            try {
                let payload = [{ "pids" : [project_id]}];
                await this.publicApiPost(`/api/v1/applicant_satisfaction_survey/sendSurveyEmails`, payload);
                this.getPendingProjects();
                this.warningNotif(
                "Encuesta de satisfacción"
                , "Se ha enviado un correo al Solicitante para el llenado de la encuesta de servicio, de la cual es necesaria su respuesta para poder realizar el pago de finiquito."
                , 15000
                );
            } catch (error) {
                this.warn(error);
                this.failedOperationNotif(null, null);
            }
            this.showLoading(false);
        },
        async handleSelected(proj){
            window.open(`/project/${proj.PID}`, '_blank');
        },
        calculateValuesSP(surveyScores){
            let result = {
                serviceAvg: 0
                , projectAvg: 0
                , single: 0
                , average: surveyScores.average
            };
            let counters = [0,0,0];
            surveyScores.values.forEach(ss => {
                switch(ss.type){
                    case "services":
                        result.serviceAvg += ss.average;
                        counters[0]++;
                        break;
                    case "projects":
                        result.projectAvg += ss.average;
                        counters[1]++;
                        break;
                    case "single":
                        result.single += ss.average;
                        counters[2]++;
                        break;
                    default: console.log("valor no comprendido");
                }
            });

            result.serviceAvg = result.serviceAvg / counters[0];
            result.projectAvg = result.projectAvg / counters[1];
            result.single = result.single / counters[2];

            return result;
        },
        getURL(item){
            if(item.DATE != null){
                return `${URL_PATH}cid=${item.CID}&pid=${item.PID}&t=${item.token}`;
            } else {
                return "--";
            }
        }, 
        async getSurvey(item){
            this.showLoading(true);
            try{
                let res = await axios.get(`/api/applicant_satisfaction_survey/${item.PID}/survey/${item.CID}`);
                this.survey = res.data;
                if(this.survey.length != 0){
                    this.projectSelected = item;
                    this.popupActivoSurvey = true;
                } else {
                    this.warningNotif(
                    "Sin respuesta"
                    , "No se han encontrado respuestas para la encuesta de servicio para este proyecto."
                    );
                }

            }catch(err){
                this.warn(err);
                this.failedOperationNotif(null, null);
            }
            this.showLoading(false);
        }, 
        getYesOrNOAnswers(question)
        {
            let isQuestion = this.spQuestionIds.some(x => x == question.id);
            if(isQuestion){
                if(question.value == "5"){
                    return "Si";
                } else {
                    return "No";
                }
            } else { return question.value }
        },
        getQuestionType(question){
            if(question.type == "RG_QUESTION"){
                return "RedGirasol";
            } else if(question.type == "SP_QUESTION") {
                return "Proveedor";
            } else {
                return "--"
            }
        }
    }
}
</script>

<style lang="css">
    .custom-font {
		font-family: 'Poppins', sans-serif !important;
    }
    .custom-font-size {
        font-size: 13px;
    }

    .custom-orange {
        color: #f39200 !important;
    }
</style>